var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "idle", attrs: { id: "idle" } }, [
        _c("img", {
          staticClass: "session",
          attrs: {
            src: require("@/assets/img/session-expires.svg?data"),
            alt: "Session warning"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        _c("span", {
          staticClass: "text-center",
          domProps: { innerHTML: _vm._s(_vm.data.error.sessionExpiredText) }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "text-center" }, [
          _vm._v(
            _vm._s(_vm.seconds) +
              " " +
              _vm._s(_vm.data.error.sessionExpiredDisclaimer)
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6f30cd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6f30cd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Session.vue
// module id = null
// module chunks = 